<template>
  <v-expansion-panel v-model="vare" expand class="panel">
    <v-expansion-panel-content>
      <template v-slot:header>
        <h2>Gráficos dos Custos</h2>
      </template>

      <v-container white grid-list-md text-xs-center text-md-center >
        <v-layout row wrap>
          <v-flex xs12 sm12 md6>
            <div class="divider2">
              <span>
                <b>Custos fixos e variáveis</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-card>
              <tab-grafico-custos-fixos-variaveis/>
            </v-card>
          </v-flex>

          <v-flex xs12 sm12 md6>
            <div class="divider2">
              <span>
                <b>Composição do custo total</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-card>
              <tab-grafico-composicao-custo-total/>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container grid-list-md text-xs-center text-md-center>
        <v-layout row wrap>
          <v-layout justify-center align-center>
            <v-flex xs12 sm12 md7>
              <div class="divider2">
                <span>
                  <b>Participação custo total</b>
                </span>
              </div>
              <v-divider></v-divider>
              <v-card>
                <tab-grafico-participacao-custo-total/>
              </v-card>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-container>

      <v-container grid-list-md text-xs-center text-md-center>
        <v-layout row wrap>
          <v-layout justify-center align-center>
            <v-flex xs12 sm12 md7>
              <div class="divider2">
                <span>
                  <b>Custo total, custo operacional e preço recebido</b>
                </span>
              </div>
              <v-divider></v-divider>
              <v-card>
                <tab-grafico-custo-operacional-preco-recebido/>
              </v-card>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-container>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
import TabGraficoCustosFixosVariaveis from "../tabs/TabGraficoCustosFixosVariaveis.vue";
import TabGraficoComposicaoCustoTotal from "../tabs/TabGraficoComposicaoCustoTotal.vue";
import TabGraficoParticipacaoCustoTotal from "../tabs/TabGraficoParticipacaoCustoTotal.vue";
import TabGraficoCustoTotalCustoOperacionalPrecoRecebido from "../tabs/TabGraficoCustoTotalCustoOperacionalPrecoRecebido.vue";
export default {
  components: {
    "tab-grafico-custos-fixos-variaveis": TabGraficoCustosFixosVariaveis,
    "tab-grafico-composicao-custo-total": TabGraficoComposicaoCustoTotal,
    "tab-grafico-participacao-custo-total": TabGraficoParticipacaoCustoTotal,
    "tab-grafico-custo-operacional-preco-recebido" : TabGraficoCustoTotalCustoOperacionalPrecoRecebido
  },
  props: ['vare'],
  data: () => ({
    panel: []
  })
};
</script>
<style scoped>
@media screen and (max-width: 991px) {
  .grafico {
    margin-top: 5%;

    margin-bottom: 3%;
  }

  .panel {
    margin-top: 3%;
    padding-bottom: 3%;
    background-color: white;
    box-shadow: 0 4px 15px black;
  }

  .button {
    margin-top: 5%;
    margin-bottom: 5%;
  }

  .divider2 {
    margin-top: 5%;
    margin-left: 5%;
    font-size: 110%;
  }
}

@media screen and (min-width: 992px) {
  .grafico {
    display: inline-block;
    margin-top: 5%;
    margin-left: 10%;
    margin-right: 1%;
    margin-bottom: 5%;
  }
  .grafico1 {
    display: inline-block;
    margin-top: 2%;
    margin-left: 30%;
    margin-right: 30%;
    margin-bottom: 5%;
  }

  .panel {
    margin-top: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 10px black;
  }

  .button {
    margin-bottom: 2%;
  }
  .divider2 {
    font-size: 150%;
    margin-top: 5%;
    margin-left: 5%;
  }
}
</style>
